import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import { useData } from "../../utility/useData";
//img
import success from "../../assets/img/success.png";
import error from "../../assets/img/error.png";

const ToastMessage = () => {
  const {
    decimals,
    initialResultMsg,
    initialData,
    reRender,
    poolData,
    showPoolDetail,
    toastArgs,
    setReRender,
    updatePoolData,
    togglePoolData,
    openData,
    closeData,
    statusText,
    setToastArgs
  } = useData();

  return (
    <>
      <ToastContainer
        className="p-3"
        position="bottom-end"
        style={{ zIndex: 99999 }}
      >
        <Toast
          onClose={() =>
            setToastArgs({
              header: null,
              messageType: null,
              message: null,
              isShow: false,
            })
          }
          show={toastArgs.isShow}
          delay={5000}
          autohide
        >
          <Toast.Header style={{ background: "#a793a1", color: "white" }}>
            <strong className="me-auto">
              {toastArgs.messageType && (<img src={toastArgs.messageType === 1 ? success : error} alt="type" width={32} />)} {toastArgs.header}
            </strong>
          </Toast.Header>
          <Toast.Body style={{ background: "#f6efe3" }}>
            {toastArgs.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default ToastMessage;
